/** Open modals in opening order, shared by every BaseModal instance so only the topmost reacts to Escape. */
const openModalStack: symbol[] = []

export function pushOpenModal(id: symbol): void {
  if (!openModalStack.includes(id)) openModalStack.push(id)
}

export function removeOpenModal(id: symbol): void {
  const i = openModalStack.indexOf(id)
  if (i !== -1) openModalStack.splice(i, 1)
}

export function isTopmostModal(id: symbol): boolean {
  return openModalStack[openModalStack.length - 1] === id
}
